<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">ວຽກງານ ICS / ຈັດການ{{ subname }}</h2>
        </div>
      </div>
      <b-tabs
        v-model="activeTab"
        v-if="roleid == 25 || roleid == 26 || roleid == 27"
      >
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂ">
          <div class="columns">
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂ</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field :label="subname">
                    <Multiselect v-if="roleid == 25"
                      placeholder="ເລືອກ"
                      v-model.trim="selectedProvince"
                      label="NAME"
                      track-by="ID"
                      :options="provinceList"
                    >
                    </Multiselect>
                    <b-field v-else-if="roleid == 26">
                      <b-input v-model.trim="district">
                      </b-input>
                    </b-field>
                    <b-field v-else-if="roleid == 27">
                      <b-input v-model.trim="group">
                      </b-input>
                    </b-field>
                    
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຜູ້ຮັບຜິດຊອບ">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="selectedUser"
                      label="FULLNAME"
                      track-by="USERNAME"
                      :options="userList"
                    >
                    </Multiselect>
                  </b-field>
                </div>
              </div>

              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveBranch" v-if="roleid==25">
                    ບັນທຶກແຂວງ
                  </button>
                  <button class="button is-info" @click="saveDistrict" v-if="roleid==26">
                    ບັນທຶກເມືອງ
                  </button>
                  <button class="button is-info" @click="saveGroup" v-if="roleid==27">
                    ບັນທຶກກຸ່ມ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns" >
                    <div class="column">
                      <b-field>
                        <button class="button is-primary" @click="updateBranch"  v-if="roleid==25">
                          ແກ້ໄຂຂໍ້ມູນແຂວງ
                        </button>
                        <button class="button is-primary" @click="updateIcsDistrict"  v-if="roleid==26">
                          ແກ້ໄຂຂໍ້ມູນເມືອງ
                        </button>
                        <button class="button is-primary" @click="updateIcsGroup"  v-if="roleid==27">
                          ແກ້ໄຂຂໍ້ມູນກຸ່ມ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button v-if="roleid==25"
                          class="button is-info"
                          @click="openSaveBranchForm" 
                        >
                          ຟອມເພີ່ມ{{ subname }}
                        </button>
                        <button v-if="roleid==26"
                          class="button is-info"
                          @click="openSaveDistrictForm" 
                        >
                          ຟອມເພີ່ມ{{ subname }}
                        </button>
                        <button v-if="roleid==27"
                          class="button is-info"
                          @click="openSaveGroupForm" 
                        >
                          ຟອມເພີ່ມ{{ subname }}
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item :label="sub_active_tab_title">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="sub_active_tab_title">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="30%">
                        {{ subname }}
                      </th>
                      <th class="has-text-left " width="15%">
                        ຜູ້ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເບີໂທຕິດຕໍ່
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="roleid==25">
                    <tr v-for="(data, index) in activebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                updateBranchForm(
                                  data.ID,
                                  data.PROVINCEID,
                                  data.PROVINCENAME,
                                  data.FULLNAME,
                                  data.USERNAME
                                )
                              "
                              >ແກ້ໄຂ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeBranchSataus(data.ID, 0)"
                              >ປິດໃຊ້ງານ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="roleid==26">
                    <tr v-for="(data, index) in activebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.DISTRICTNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                updateIcsDistrictForm(
                                  data.ID,
                                  data.DISTRICTNAME,
                                  data.FULLNAME,
                                  data.USERNAME
                                )
                              "
                              >ແກ້ໄຂເມືອງ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeBranchSataus(data.ID, 0)"
                              >ປິດໃຊ້ງານ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="roleid==27">
                    <tr v-for="(data, index) in activebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.GROUPNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                updateIcsGroupForm(
                                  data.ID,
                                  data.GROUPNAME,
                                  data.FULLNAME,
                                  data.USERNAME
                                )
                              "
                              >ແກ້ໄຂກຸ່ມ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeBranchSataus(data.ID, 0)"
                              >ປິດໃຊ້ງານ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item :label="sub_inactive_tab_title">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="sub_inactive_tab_title">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="30%">
                        {{subname}}
                      </th>
                      <th class="has-text-left " width="15%">
                        ຜູ້ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເບີໂທຕິດຕໍ່
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="subroleid==26">
                    <tr v-for="(data, index) in inactivebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PROVINCENAME }} 
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>
                      <td>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="changeBranchSataus(data.ID, 1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="subroleid==27">
                    <tr v-for="(data, index) in inactivebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.DISTRICTNAME }} 
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>
                      <td>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="changeBranchSataus(data.ID, 1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="subroleid==28">
                    <tr v-for="(data, index) in inactivebranches" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.GROUPNAME }} 
                      </td>
                      <td>
                        {{ data.FULLNAME  }}
                      </td>
                      <td>
                        {{ data.PHONENO  }}
                      </td>
                      <td>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="changeBranchSataus(data.ID, 1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      subroleid: null,
      subname: null,
      userName: null,
      selectedCountry: null,
      countryList: [],
      isProvinceSelected: false,
      selectedProvince: null,
      district: null,
      olddistrict: null,
      districtid: null,
      group: null,
      oldgroup: null,
      groupid: null,
      provinceList: [],
      // districtList: [],
      // groupList: [],
      selectedUser: null,
      userList: [],

      activebranches: [],
      inactivebranches: [],
      branchid: null,
      oldbranchname: null,
      branchname: null,
      oldbranchenname: null,
      branchenname: null,
      countryid: null,
      provinceid: null,
      oldprovinceid: null,
      responseusername: null,
      oldresponseusername: null,

      activeTab: 1,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      sub_active_tab_title: null, 
      sub_inactive_tab_title: null,
      provinceid_of_agrizone_province: null,
      agrizone_provinceid: null,
      agrizone_districtid: null,
      
    };
  },
  methods: {
    getResponseUser(subroleid) {
      RestAPI.getResponseIcsUser(subroleid)
        .then((res) => {
          console.log("getResponseUser: "+ JSON.stringify(res.data))
          if (this.updateAction == true) {
            this.userList = res.data;
            this.userList.push(this.selectedUser);
          }

          this.userList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProvince() {
      RestAPI.getProvincebyCountry(1)
        .then((res) => {
          // console.log("getProvince...: " +  JSON.stringify(res.data));
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    // getIcsDistrict() {
    //   RestAPI.getIcsDistrict(this.roleid)
    //     .then((res) => {
    //       this.districtList = res.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    // getIcsGrouop() {
    //   RestAPI.getIcsGrouop(this.roleid)
    //     .then((res) => {
    //       this.grouopList = res.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    saveBranch() {
      if (
        this.selectedProvince === null ||
        this.selectedUser === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          provinceid: this.selectedProvince.ID,
          provincename: this.selectedProvince.NAME,
          username: this.selectedUser.USERNAME,
          updateby: this.username,
          roleid: this.subroleid
        };
        RestAPI.saveBranchofIcs(params)
          .then((res) => {
            // console.log("data: " + JSON.stringify(res.data))
            
            if (res.data == "duplicate province") {
              this.$swal(
                this.selectedProvince.NAME + " ມີແຂວງຢູ່ແລ້ວ",
                "-",
                "error"
              );
              return false;
            }

            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.selectedProvince = null;
            this.selectedUser = null;
            this.getBranches();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getBranches() {
      // console.log("this.subroleid: " + this.subroleid);
      RestAPI.getProvincesofIcs(this.subroleid)
        .then((res) => {
           console.log("getBranches list:" + JSON.stringify(res.data));
          this.activebranches = res.data.activebranches;
          this.inactivebranches = res.data.inactivebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateBranchForm(
      ID,
      PROVINCEID,
      PROVINCENAME,
      FULLNAME,
      USERNAME
    ) {

      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.branchid = ID;
      this.provinceid = PROVINCEID;
      this.oldprovinceid = PROVINCEID;
      this.responseusername = USERNAME;
      this.oldresponseusername = USERNAME;
      this.selectedProvince = { ID: PROVINCEID, NAME: PROVINCENAME };
      this.selectedUser = { USERNAME: USERNAME, FULLNAME: FULLNAME };
      this.getResponseUser(this.subroleid);
    },
    openSaveBranchForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.selectedProvince = null;
      this.selectedUser = null;
    },
    updateBranch() { 
      if (
        this.selectedProvince === null ||
        this.selectedUser === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      }
      var params = {
        id: this.branchid,
        provinceid: this.selectedProvince.ID,
        provincename: this.selectedProvince.NAME,
        oldprovinceid: this.oldprovinceid,
        responseusername: this.selectedUser.USERNAME,
        oldresponseusername: this.oldresponseusername,
        updateby: this.username,
      };

      console.log("params: "+ JSON.stringify(params))

      RestAPI.updateIcsBranch(params)
        .then((res) => {
          
          if (res.data == "duplicate province") {
            this.$swal(
              this.selectedProvince.NAME + " ມີແຂວງຢູ່ແລ້ວ",
              "-",
              "error"
            );
            return false;
          }

          this.$swal("ແກ້ໄຂຂໍ້ມູນ ສຳເລັດ!", "", "success");
          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.provinceid = null;
          this.responseusername = null;
          this.getBranches();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    changeBranchSataus(subid, status) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            subid: subid,
            roleid: this.subroleid,
            status: status,
            username: this.username,
          };
          RestAPI.changeBranchofIcsSataus(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getBranches();
              this.getDistrict();
              this.getGroup();
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    saveDistrict() {
      if (
        this.district === null ||
        this.selectedUser === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          provinceid: this.provinceid_of_agrizone_province,
          agrizone_provinceid: this.agrizone_provinceid,
          district: this.district,
          username: this.selectedUser.USERNAME,
          updateby: this.username,
          roleid: this.subroleid
        };
        console.log("params: ", JSON.stringify(params))
        RestAPI.saveIcsDistrict(params)
          .then((res) => {
            if (res.data == "duplicate district") {
              this.$swal(
                this.district + " ມີເມືອງນີ້ຢູ່ແລ້ວ",
                "-",
                "error"
              );
              return false;
            }

            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.district = null;
            this.selectedUser = null;
            this.getDistrict();
            this.activeTab = 1;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getDistrict() {
      RestAPI.getIcsDistrict(this.agrizone_provinceid)
        .then((res) => {
          // console.log("getDistrict res:" + JSON.stringify(res.data))
          this.activebranches = res.data.activebranches;
          this.inactivebranches = res.data.inactivebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   
    updateIcsDistrictForm(
      ID,
      DISTRICTNAME,
      FULLNAME,
      USERNAME
    ) {

      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.district = DISTRICTNAME;
      this.olddistrict = DISTRICTNAME;
      this.districtid = ID;
      this.responseusername = USERNAME;
      this.oldresponseusername = USERNAME;
      this.selectedUser = { USERNAME: USERNAME, FULLNAME: FULLNAME };
      this.getResponseUser(this.subroleid);
    },
    openSaveDistrictForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.district = null; 
      this.selectedUser = null;
    },
    updateIcsDistrict() { 
      if (
        this.district === null ||
        this.selectedUser === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      }
      var params = {
        id: this.districtid,
        district: this.district,
        olddistrict: this.olddistrict,
        responseusername: this.selectedUser.USERNAME,
        oldresponseusername: this.oldresponseusername,
        updateby: this.username,
      };

      console.log("params district: "+ JSON.stringify(params))

      RestAPI.updateIcsDistrict(params)
        .then((res) => {
          
          if (res.data == "duplicate district") {
            this.$swal(
              this.selectedProvince.NAME + " ມີເມືອງນີ້ຢູ່ແລ້ວ",
              "-",
              "error"
            );
            return false;
          }

          this.$swal("ແກ້ໄຂຂໍ້ມູນ ສຳເລັດ!", "", "success");
          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.district = null;
          this.responseusername = null;
          this.getDistrict();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    saveGroup() {
      if (
        this.group === null 
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          provinceid: this.provinceid_of_agrizone_province,
          agrizone_provinceid: this.agrizone_provinceid,
          agrizone_districtid: this.agrizone_districtid,
          group: this.group,
          username: this.selectedUser.USERNAME,
          updateby: this.username,
          roleid: this.subroleid
        };
        // console.log("saveGroup params: ", JSON.stringify(params))
        RestAPI.saveIcsGroup(params)
          .then((res) => {
            if (res.data == "duplicate group") {
              this.$swal(
                this.district + " ມີກຸ່ມນີ້ຢູ່ແລ້ວ",
                "-",
                "error"
              );
              return false;
            }

            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.group = null;
            this.selectedUser = null;
            this.getGroup();
            this.activeTab = 1;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getGroup() {
      RestAPI.getIcsGroup(this.agrizone_districtid) 
        .then((res) => {
          // console.log("getDistrict res:" + JSON.stringify(res.data))
          this.activebranches = res.data.activebranches;
          this.inactivebranches = res.data.inactivebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   
    updateIcsGroupForm(
      ID,
      GROUPNAME,
      FULLNAME,
      USERNAME
    ) {

      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.group = GROUPNAME;
      this.oldgroup = GROUPNAME;
      this.groupid = ID;
      this.responseusername = USERNAME;
      this.oldresponseusername = USERNAME;
      this.selectedUser = { USERNAME: USERNAME, FULLNAME: FULLNAME };
      this.getResponseUser(this.subroleid);
    },
    openSaveGroupForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.group = null; 
      this.selectedUser = null;
    },
    updateIcsGroup() { 
      if (
        this.group === null 
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      }
      var params = {
        id: this.groupid,
        group: this.group,
        oldgroup: this.oldgroup,
        responseusername: this.selectedUser.USERNAME,
        oldresponseusername: this.oldresponseusername,
        updateby: this.username,
      };

      // console.log("params group: "+ JSON.stringify(params))

      RestAPI.updateIcsGroup(params)
        .then((res) => {
          
          if (res.data == "duplicate group") {
            this.$swal(
              this.selectedProvince.NAME + " ມີກຸ່ມນີ້ຢູ່ແລ້ວ",
              "-",
              "error"
            );
            return false;
          }

          this.$swal("ແກ້ໄຂຂໍ້ມູນ ສຳເລັດ!", "", "success");
          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.group = null;
          this.responseusername = null;
          this.getGroup();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    console.log(" this.user: ", JSON.stringify( this.user.ROLEID))
    this.username = this.user.USERNAME;
    this.agrizone_provinceid= this.user.AGRIZONE_PROVINCEID ? this.user.AGRIZONE_PROVINCEID : '';
    this.provinceid_of_agrizone_province = this.user.PROINCEID_OF_AGRIZONE_PROVINCE ? this.user.PROINCEID_OF_AGRIZONE_PROVINCE : '';
    this.agrizone_districtid= this.user.AGRIZONE_DISTRICTID ? this.user.AGRIZONE_DISTRICTID : '';
    this.subroleid =
      this.user.ROLEID == 25
        ? 26
        : this.user.ROLEID == 26
        ? 27
        : this.user.ROLEID == 27
        ? 28
        : "--";
    this.subname =
      this.user.ROLEID == 25
        ? "ແຂວງ"
        : this.user.ROLEID == 26
        ? "ເມືອງ"
        : this.user.ROLEID == 27
        ? "ກຸ່ມ"
        : "";
    this.sub_active_tab_title =
      this.user.ROLEID == 25
        ? 'ແຂວງ ທີ່ເປີດໃຊ້ງານ'
        : this.user.ROLEID == 26
        ? 'ເມືອງ ທີ່ເປີດໃຊ້ງານ'
        : this.user.ROLEID == 27
        ? 'ກຸ່ມ ທີ່ເປີດໃຊ້ງານ'
        : "--";
    this.sub_inactive_tab_title =
      this.user.ROLEID == 25
        ? 'ແຂວງ ທີ່ຖືກປິດ'
        : this.user.ROLEID == 26
        ? 'ເມືອງ ທີ່ຖືກປິດ'
        : this.user.ROLEID == 27
        ? 'ກຸ່ມ ທີ່ຖືກປິດ'
        : "--";
    this.getResponseUser(this.subroleid);
    this.getBranches();
    if(this.user.ROLEID==25){
      this.getProvince();
    }else if(this.user.ROLEID==26){
      this.getDistrict();
    }else if(this.user.ROLEID==27){
      this.getGroup();
    }

    //  console.log("agrizone_provinceid: ");
    
    
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
